import { VaccinationCharacteristics } from "@syadem/vaccination-characteristics";
import type { LocaleString } from "../translations";

const requests = new Map<LocaleString, Promise<VaccinationCharacteristics>>();

export function loadVaccinationCharacteristics(locale: LocaleString): Promise<VaccinationCharacteristics> {
  const pending = requests.get(locale);

  if (pending) return pending;

  const request = VaccinationCharacteristics.load({ lang: locale === "en-gb" ? "en" : locale }).catch((error) => {
    requests.delete(locale);
    throw error;
  });

  requests.set(locale, request);
  
  return request;
}
